// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2gB7K","list":"PatternAutocomplete_list__21JYg"};